<div class="div-flex-buttons">
  <div class="div-padding-right-10">@if (hasRejectPermission) {
    <button type="button" class="btn btn-primary" name="btnSubmit" value="Reject" (click)="openDialog()" [disabled]="approved">Reject</button>
  }</div>
  <div class="div-padding-right-10">@if (hasApprovePermission) {
    <button type="button" class="btn btn-primary" name="btnSubmit" value="Approve" (click)="Approve()"  [disabled]="approved">Approve</button>
  }</div>
</div>
